import { render, staticRenderFns } from "./TwoXaxisChart.vue?vue&type=template&id=136132fc&"
import script from "./TwoXaxisChart.vue?vue&type=script&lang=js&"
export * from "./TwoXaxisChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports